import {Shift, ShiftType} from "@/src/modules/shifts/types";

/** Routed patrols (or visits already on the shift) show the checkpoint checklist. */
export function showPatrolCheckpoints(shift: Shift): boolean {
  if (shift.type !== ShiftType.PATROL) return false;
  const visits = shift.patrol_visits ?? [];
  return Boolean(shift.patrol_route || visits.length);
}
